import { useMutation } from '@th/react-query';
import { PropertyInquiryFormInfo } from '@th/shared/src/types/PropertyInquiry';
import AxiosClient from '@th/frontend-shared/src/utils/AxiosClient';
import { AxiosError } from 'axios';
import logAxiosError from '@th/frontend-shared/src/utils/logAxiosError';

export default function useCreatePropertyInquiry() {
  const { mutate, mutateAsync, isLoading, isSuccess } = useMutation(
    async (propertyInquiryInfo: PropertyInquiryFormInfo) => {
      await AxiosClient.post('/api/v2/propertyInquiries', propertyInquiryInfo);
    },
    {
      onError: async (err: AxiosError) => {
        logAxiosError('useCreatePropertyInquiry', err);
      },
    },
  );

  return { mutate, mutateAsync, isLoading, isSuccess };
}
